<mat-form-field [class.mat-select-readonly]="!editing" appearance="outline" class="w-100" floatLabel="always">
    <mat-label>Doing Business As</mat-label>
    <mat-select [panelClass]="!editing ? 'd-none' : ''" [disabled]="editing && loading" [value]="value" [compareWith]="compare"
        [placeholder]="loading ? 'Loading...' : 'Company name'" (selectionChange)="onChange($event.value); idValueChange.emit($event.value.companyId)">
        <mat-option *ngFor="let comp of companies" [value]="comp">
            {{ comp.name }}
        </mat-option>
    </mat-select>
</mat-form-field>